import { Component } from '@angular/core';
import {Router} from '@angular/router';

@Component({
  selector: 'app-settings-page',
  templateUrl: './settings-page.component.html',
  styleUrls: ['./settings-page.component.scss']
})
export class SettingsPageComponent {

  constructor(private router: Router) { }

  showLeadSources() {
    this.router.navigate(['settings', 'lead-sources']);
  }

}
